import {
  Box,
  HStack,
  Icon,
  Spinner,
  Tag,
  TagLabel,
  Text,
  VStack,
} from "@chakra-ui/react";
import amplitude from "amplitude-js";
import { motion } from "framer-motion";
import React, { Component, useEffect, useState } from "react";
import CountUp from "react-countup";
import Confetti from "react-dom-confetti";
import { connect } from "react-redux";
import {
  Banner,
  PromoCouponBanner,
  SecondaryButton,
  Title,
  TriangleDown,
  TriangleUp,
} from "../design_library";
import stylesX from "../design_library/index.module.css";
import "./App.css";
import apiCalls from "../platform/helpers/apiCalls";
import HistoricalOptionData from "../platform/trades/subcomponents/HistoricalOptionData";
import WealthBeeBanner from "./WealthBeeBanner";

const ExampleCharts = React.lazy(() =>
  import("../platform/dashboard/DynamicDashboard/ExampleCharts")
);
const AccountPicker = React.lazy(() =>
  import("../platform/header/AccountPicker")
);
const styles = React.lazy(() => import("./App.module.css"));
const Footer = React.lazy(() => import("./footer/App"));
const Gallery = React.lazy(() => import("./gallery/App"));
const Features = React.lazy(() => import("./headers/Features/App"));
const Hero = React.lazy(() => import("./headers/Hero/App"));
const SimpleHeader = React.lazy(() => import("./headers/SimpleHeader"));
const NavBar = React.lazy(() => import("./menu/App"));
const TryItOut1 = React.lazy(() => import("./tryitout/TryItOut"));
const Pricing = React.lazy(() => import("./pricing/App"));
const TextSection = React.lazy(() => import("./TextSection/App"));

const Upload = React.lazy(() => import("./upload/Upload"));
// const Testimonial = React.lazy(() => import('./testimonials/App'));
// const MainApp = React.lazy(() => import('./platform/MainApp'));

const { colorMode } = "";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfetti: false,
      trial_days: 30,
      trial_days_loading: true,
      loading: true,
      iAmMounted: false,
    };
  }

  setIntercomSettings = () => {
    // window.Intercom("boot", {
    //   app_id: "zb1u5bz5",
    //   custom_launcher_selector: '#my_custom_link',
    //   alignment: "left",
    // });
  };

  componentDidMount() {
    if (
      navigator.userAgent === "ReactSnap" ||
      window.location.href === "http://localhost:3000/" ||
      window.location.href === "https://optiontracker.io/" ||
      window.location.href === "https://beta.optiontracker.io/" ||
      window.location.href === "https://alpha.optiontracker.io/" ||
      window.location.href === "https://optiontracker.io/?via=install" ||
      window.location.href === "http://localhost:3000/?via=install"
    ) {
      console.log("Dashboard being mounted...");
      const isLocalhost = Boolean(
        window.location.hostname === "localhost" ||
          // [::1] is the IPv6 localhost address.
          window.location.hostname === "[::1]" ||
          // 127.0.0.1/8 is considered localhost for IPv4.
          window.location.hostname.match(
            /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
          )
      );

      if (!isLocalhost) {
        this.setIntercomSettings();
      }

      amplitude.getInstance().init("8d502256174ed7d512d53d41877f095d");
      amplitude.getInstance().logEvent("V2.Homepage.User_visits_homepage");

      if (navigator.userAgent !== "ReactSnap") {
        apiCalls
          .getSubscriptionMetaData()
          .then((res) => {
            this.setState({
              trial_days: res.trial_period_days,
              trial_days_loading: false,
              promo: res.sale,
              loading: false,
              iAmMounted: true,
            });
          })
          .catch((e) => {
            console.log(e);
            this.setState({
              trial_days: 30,
              trial_days_loading: false,
              promo: { active: false },
              loading: false,
              iAmMounted: true,
            });
          });
      } else {
        this.setState({
          trial_days: 30,
          trial_days_loading: false,
          promo: { active: false },
          loading: false,
          iAmMounted: true,
        });
      }
    } else {
      console.log("Does not match.", window.location.href);

      this.setState({
        trial_days: 30,
        trial_days_loading: false,
        promo: { active: false },
        loading: false,
        iAmMounted: true,
      });
    }
  }

  render() {
    if (this.state.iAmMounted !== true) {
      // return <Box width="100%" height="100vh" display={'flex'} justifyContent='center' alignItems={'center'}>
      //   <Spinner />

      // </Box>;

      return <></>;
    }

    let examplechartdata = {
      success: true,
      greeks: [
        {
          id: "impliedVolatility",
          data: [
            {
              x: "10th May 22",
              y: 20.953,
            },
            {
              x: "12th May 22",
              y: 20.1194,
            },
            {
              x: "13th May 22",
              y: 19.9991,
            },
            {
              x: "15th May 22",
              y: 19.9991,
            },
            {
              x: "16th May 22",
              y: 19.9801,
            },
            {
              x: "16th May 22",
              y: 19.9801,
            },
            {
              x: "18th May 22",
              y: 19.8566,
            },
            {
              x: "20th May 22",
              y: 19.4649,
            },
            {
              x: "20th May 22",
              y: 19.4649,
            },
            {
              x: "23rd May 22",
              y: 19.4649,
            },
            {
              x: "24th May 22",
              y: 20.2588,
            },
          ],
        },
        {
          id: "delta",
          data: [
            {
              x: "10th May 22",
              y: 21.75,
            },
            {
              x: "12th May 22",
              y: 17.72,
            },
            {
              x: "13th May 22",
              y: 21.41,
            },
            {
              x: "15th May 22",
              y: 21.41,
            },
            {
              x: "16th May 22",
              y: 20.57,
            },
            {
              x: "16th May 22",
              y: 20.57,
            },
            {
              x: "18th May 22",
              y: 16.91,
            },
            {
              x: "20th May 22",
              y: 15.32,
            },
            {
              x: "20th May 22",
              y: 15.32,
            },
            {
              x: "23rd May 22",
              y: 15.32,
            },
            {
              x: "24th May 22",
              y: 17.94,
            },
          ],
        },
        {
          id: "rho",
          data: [
            {
              x: "10th May 22",
              y: 49.54,
            },
            {
              x: "12th May 22",
              y: 39.92,
            },
            {
              x: "13th May 22",
              y: 48.78,
            },
            {
              x: "15th May 22",
              y: 48.78,
            },
            {
              x: "16th May 22",
              y: 46.23,
            },
            {
              x: "16th May 22",
              y: 46.23,
            },
            {
              x: "18th May 22",
              y: 37.53,
            },
            {
              x: "20th May 22",
              y: 33.77,
            },
            {
              x: "20th May 22",
              y: 33.77,
            },
            {
              x: "23rd May 22",
              y: 33.77,
            },
            {
              x: "24th May 22",
              y: 0,
            },
          ],
        },
        {
          id: "theta",
          data: [
            {
              x: "10th May 22",
              y: 3.71,
            },
            {
              x: "12th May 22",
              y: 3.11,
            },
            {
              x: "13th May 22",
              y: 3.54,
            },
            {
              x: "15th May 22",
              y: 3.54,
            },
            {
              x: "16th May 22",
              y: 3.47,
            },
            {
              x: "16th May 22",
              y: 3.47,
            },
            {
              x: "18th May 22",
              y: 3.0300000000000002,
            },
            {
              x: "20th May 22",
              y: 2.77,
            },
            {
              x: "20th May 22",
              y: 2.77,
            },
            {
              x: "23rd May 22",
              y: 2.77,
            },
            {
              x: "24th May 22",
              y: 3.26,
            },
          ],
        },
        {
          id: "vega",
          data: [
            {
              x: "10th May 22",
              y: 97.72999999999999,
            },
            {
              x: "12th May 22",
              y: 84.56,
            },
            {
              x: "13th May 22",
              y: 96.91,
            },
            {
              x: "15th May 22",
              y: 96.91,
            },
            {
              x: "16th May 22",
              y: 93.71000000000001,
            },
            {
              x: "16th May 22",
              y: 93.71000000000001,
            },
            {
              x: "18th May 22",
              y: 81.05,
            },
            {
              x: "20th May 22",
              y: 75.24,
            },
            {
              x: "20th May 22",
              y: 75.24,
            },
            {
              x: "23rd May 22",
              y: 75.24,
            },
            {
              x: "24th May 22",
              y: 83.53,
            },
          ],
        },
        {
          id: "gamma",
          data: [
            {
              x: "10th May 22",
              y: 0.42,
            },
            {
              x: "12th May 22",
              y: 0.4,
            },
            {
              x: "13th May 22",
              y: 0.44,
            },
            {
              x: "15th May 22",
              y: 0.44,
            },
            {
              x: "16th May 22",
              y: 0.43,
            },
            {
              x: "16th May 22",
              y: 0.43,
            },
            {
              x: "18th May 22",
              y: 0.38999999999999996,
            },
            {
              x: "20th May 22",
              y: 0.38,
            },
            {
              x: "20th May 22",
              y: 0.38,
            },
            {
              x: "23rd May 22",
              y: 0.38,
            },
            {
              x: "24th May 22",
              y: 0.4,
            },
          ],
        },
      ],
      trades: [
        {
          stockTicker: "TWTR",
          tradeType: "CALL",
          action: "SELL_TO_OPEN",
          positionStatus: "OPEN",
          contracts: 1,
          premium: 1.14,
          spotPriceAtTradeTime: 24.15,
          strikePrice: 70,
          strategy: "Naked puts",
          realisedProfitAndLoss: 10.5,
          dateOpened: "2021-03-28T23:00:00.000Z",
          dateClosed: null,
        },
        {
          stockTicker: "TWTR",
          tradeType: "STOCK",
          action: "BUY",
          positionStatus: "OPEN",
          quantity: 100,
          spotPriceAtTradeTime: 69,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: -1300,
          dateOpened: "2021-04-15T23:00:00.000Z",
          dateClosed: "2021-04-18T23:00:00.000Z",
        },
        {
          stockTicker: "FNKO",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 2,
          spotPriceAtTradeTime: 21.4,
          strikePrice: 20,
          strategy: "Naked puts",
          realisedProfitAndLoss: 2.1,
          dateOpened: "2021-04-29T00:00:00.000Z",
          dateClosed: "2021-05-11T00:00:00.000Z",
        },
        {
          stockTicker: "X",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 1.01,
          spotPriceAtTradeTime: 25.78,
          strikePrice: 23,
          strategy: "Naked puts",
          realisedProfitAndLoss: 0.21999999999999997,
          dateOpened: "2021-05-04T00:00:00.000Z",
          dateClosed: "2021-05-12T00:00:00.000Z",
        },
        {
          stockTicker: "SNAP",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 2,
          spotPriceAtTradeTime: 52.03,
          strikePrice: 47.5,
          strategy: "Naked puts",
          realisedProfitAndLoss: 1.49,
          dateOpened: "2021-05-17T00:00:00.000Z",
          dateClosed: "2021-05-24T00:00:00.000Z",
        },
        {
          stockTicker: "TECL",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.41,
          spotPriceAtTradeTime: 46.03,
          strikePrice: 42.5,
          strategy: "Naked puts",
          realisedProfitAndLoss: 0.15999999999999992,
          dateOpened: "2021-05-25T00:00:00.000Z",
          dateClosed: "2021-06-01T00:00:00.000Z",
        },
        {
          stockTicker: "APPS",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 1.7,
          spotPriceAtTradeTime: 66.19,
          strikePrice: 60,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: 3.4,
          dateOpened: "2021-05-28T00:00:00.000Z",
          dateClosed: "2021-06-06T00:00:00.000Z",
        },
        {
          stockTicker: "JWN",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.07,
          spotPriceAtTradeTime: 34.86,
          strikePrice: 32.5,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: -0.48,
          dateOpened: "2021-06-14T00:00:00.000Z",
          dateClosed: "2021-06-21T00:00:00.000Z",
        },
        {
          stockTicker: "URA",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 3,
          quantity: null,
          premium: 0.9,
          spotPriceAtTradeTime: 22.208,
          strikePrice: 21,
          strategy: "Naked puts",
          realisedProfitAndLoss: 1.5,
          dateOpened: "2021-06-15T00:00:00.000Z",
          dateClosed: "2021-06-29T00:00:00.000Z",
        },
        {
          stockTicker: "UNFI",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.6,
          spotPriceAtTradeTime: 36.54,
          strikePrice: 35,
          strategy: "Naked puts",
          realisedProfitAndLoss: 0.8700000000000001,
          dateOpened: "2021-06-17T00:00:00.000Z",
          dateClosed: "2021-06-25T00:00:00.000Z",
        },
        {
          stockTicker: "X",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.05,
          spotPriceAtTradeTime: 23.94,
          strikePrice: 23,
          strategy: "Naked puts",
          realisedProfitAndLoss: 1.05,
          dateOpened: "2021-06-23T00:00:00.000Z",
          dateClosed: "2021-07-19T00:00:00.000Z",
        },
        {
          stockTicker: "PRTS",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 3,
          premium: 0.84,
          spotPriceAtTradeTime: 15,
          strikePrice: 12.5,
          strategy: "Naked puts",
          realisedProfitAndLoss: 1.44,
          dateOpened: "2021-03-31T23:00:00.000Z",
          dateClosed: "2021-04-19T00:00:00.000Z",
        },
        {
          stockTicker: "GPS",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 0.94,
          spotPriceAtTradeTime: 33.95,
          strikePrice: 32,
          strategy: "Long call",
          realisedProfitAndLoss: -11.88,
          dateOpened: "2021-06-25T00:00:00.000Z",
          dateClosed: "2021-07-30T23:00:00.000Z",
        },
        {
          stockTicker: "TIGR",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          premium: 0.96,
          spotPriceAtTradeTime: 26.58,
          strikePrice: 20,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: 1.82,
          dateOpened: "2021-02-04T00:00:00.000Z",
          dateClosed: null,
        },
        {
          stockTicker: "PLTR",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 3,
          premium: 1.5,
          spotPriceAtTradeTime: 24.18,
          strikePrice: 22.5,
          strategy: "Naked puts",
          realisedProfitAndLoss: 1.95,
          dateOpened: "2021-03-22T00:00:00.000Z",
          dateClosed: "2021-04-08T23:00:00.000Z",
        },
        {
          stockTicker: "PLTR",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          premium: 1.44,
          spotPriceAtTradeTime: 28,
          strikePrice: 21,
          strategy: "Naked puts",
          realisedProfitAndLoss: 1.8,
          dateOpened: "2021-02-19T00:00:00.000Z",
          dateClosed: null,
        },
        {
          stockTicker: "MARA",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          premium: 1.55,
          spotPriceAtTradeTime: 33.88,
          strikePrice: 24,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: 1.44,
          dateOpened: "2021-02-24T00:00:00.000Z",
          dateClosed: null,
        },
        {
          stockTicker: "RIOT",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          premium: 0.7,
          spotPriceAtTradeTime: 23.04,
          strikePrice: 20,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: 1.3,
          dateOpened: "2021-02-04T00:00:00.000Z",
          dateClosed: null,
        },
        {
          stockTicker: "UUUU",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 13,
          premium: 0.35,
          spotPriceAtTradeTime: 5.23,
          strikePrice: 5,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: 4.55,
          dateOpened: "2021-03-10T00:00:00.000Z",
          dateClosed: null,
        },
        {
          stockTicker: "SNAP",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          premium: 2.66,
          spotPriceAtTradeTime: 56.6,
          strikePrice: 50,
          strategy: "Naked puts",
          realisedProfitAndLoss: 2.66,
          dateOpened: "2021-04-05T23:00:00.000Z",
          dateClosed: "2021-04-07T23:00:00.000Z",
        },
        {
          stockTicker: "BBBY",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          premium: 1.01,
          spotPriceAtTradeTime: 31.11,
          strikePrice: 25,
          strategy: "Naked puts",
          realisedProfitAndLoss: 0.9,
          dateOpened: "2021-03-16T00:00:00.000Z",
          dateClosed: "2021-04-08T23:00:00.000Z",
        },
        {
          stockTicker: "MARA",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 3,
          premium: 1.4,
          spotPriceAtTradeTime: 30,
          strikePrice: 17,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: 2.91,
          dateOpened: "2021-02-08T00:00:00.000Z",
          dateClosed: null,
        },
        {
          stockTicker: "CAN",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          premium: 1.21,
          spotPriceAtTradeTime: 17.47,
          strikePrice: 10,
          strategy: "Naked puts",
          realisedProfitAndLoss: 0.88,
          dateOpened: "2021-02-17T00:00:00.000Z",
          dateClosed: null,
        },
        {
          stockTicker: "MARA",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 3,
          premium: 2.6,
          spotPriceAtTradeTime: 37.9,
          strikePrice: 30,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: 4.8,
          dateOpened: "2021-03-24T00:00:00.000Z",
          dateClosed: null,
        },
        {
          stockTicker: "APPS",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          premium: 4.62,
          spotPriceAtTradeTime: 85.46,
          strikePrice: 75,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: -22.96,
          dateOpened: "2021-04-06T00:00:00.000Z",
          dateClosed: "2021-05-12T00:00:00.000Z",
        },
        {
          stockTicker: "CCIV",
          tradeType: "STOCK",
          action: "BUY",
          positionStatus: "CLOSED",
          quantity: 100,
          spotPriceAtTradeTime: 30,
          strategy: "Naked puts",
          realisedProfitAndLoss: -1020,
          dateOpened: "2021-04-15T23:00:00.000Z",
          dateClosed: "2021-04-19T00:00:00.000Z",
        },
        {
          stockTicker: "CLNE",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 3,
          quantity: null,
          premium: 0.65,
          spotPriceAtTradeTime: 12.9,
          strikePrice: 11,
          strategy: "Naked puts",
          realisedProfitAndLoss: -6.75,
          dateOpened: "2021-04-19T00:00:00.000Z",
          dateClosed: "2021-05-12T00:00:00.000Z",
        },
        {
          stockTicker: "SNAP",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.69,
          spotPriceAtTradeTime: 54.3,
          strikePrice: 47,
          strategy: "Naked puts",
          realisedProfitAndLoss: 1.44,
          dateOpened: "2021-05-04T00:00:00.000Z",
          dateClosed: "2021-05-24T00:00:00.000Z",
        },
        {
          stockTicker: "KLIC",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 0.8,
          spotPriceAtTradeTime: 49.28,
          strikePrice: 44,
          strategy: "Naked puts",
          realisedProfitAndLoss: 0.5800000000000001,
          dateOpened: "2021-05-19T23:00:00.000Z",
          dateClosed: "2021-06-01T00:00:00.000Z",
        },
        {
          stockTicker: "MGM",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.22,
          spotPriceAtTradeTime: 39.28,
          strikePrice: 37,
          strategy: "Naked puts",
          realisedProfitAndLoss: 0.69,
          dateOpened: "2021-05-19T23:00:00.000Z",
          dateClosed: "2021-05-24T00:00:00.000Z",
        },
        {
          stockTicker: "XLF",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 0.7,
          spotPriceAtTradeTime: 37.7,
          strikePrice: 37,
          strategy: "Naked puts",
          realisedProfitAndLoss: 0.35999999999999993,
          dateOpened: "2021-05-24T00:00:00.000Z",
          dateClosed: "2021-06-04T00:00:00.000Z",
        },
        {
          stockTicker: "X",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 1.13,
          spotPriceAtTradeTime: 26.26,
          strikePrice: 24,
          strategy: "Naked puts",
          realisedProfitAndLoss: 1.1799999999999997,
          dateOpened: "2021-06-01T00:00:00.000Z",
          dateClosed: "2021-06-10T23:00:00.000Z",
        },
        {
          stockTicker: "TWTR",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.4,
          spotPriceAtTradeTime: 58.7,
          strikePrice: 55,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: 0.7,
          dateOpened: "2021-06-08T00:00:00.000Z",
          dateClosed: "2021-06-14T00:00:00.000Z",
        },
        {
          stockTicker: "ANF",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.23,
          spotPriceAtTradeTime: 41.35,
          strikePrice: 38,
          strategy: "Naked puts",
          realisedProfitAndLoss: 0.49,
          dateOpened: "2021-06-08T00:00:00.000Z",
          dateClosed: "2021-06-17T00:00:00.000Z",
        },
        {
          stockTicker: "ANF",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.15,
          spotPriceAtTradeTime: 43.15,
          strikePrice: 40,
          strategy: "Naked puts",
          realisedProfitAndLoss: -0.18000000000000016,
          dateOpened: "2021-06-14T00:00:00.000Z",
          dateClosed: "2021-06-17T00:00:00.000Z",
        },
        {
          stockTicker: "UUUU",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 12,
          quantity: null,
          premium: 0.51,
          spotPriceAtTradeTime: 6.51,
          strikePrice: 6,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: -13.080000000000002,
          dateOpened: "2021-06-24T00:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "APPS",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.65,
          spotPriceAtTradeTime: 79.6,
          strikePrice: 71.5,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: -6.42,
          dateOpened: "2021-06-28T00:00:00.000Z",
          dateClosed: "2021-07-23T00:00:00.000Z",
        },
        {
          stockTicker: "STX",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 2.6,
          spotPriceAtTradeTime: 89.14,
          strikePrice: 85,
          strategy: "Long call",
          realisedProfitAndLoss: 2.43,
          dateOpened: "2021-07-13T00:00:00.000Z",
          dateClosed: "2021-08-10T00:00:00.000Z",
        },
        {
          stockTicker: "BK",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.1,
          spotPriceAtTradeTime: 51.54,
          strikePrice: 50,
          strategy: "Long call",
          realisedProfitAndLoss: 0.43000000000000005,
          dateOpened: "2021-06-29T00:00:00.000Z",
          dateClosed: "2021-07-27T00:00:00.000Z",
        },
        {
          stockTicker: "TWTR",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 2.47,
          spotPriceAtTradeTime: 68.62,
          strikePrice: 64,
          strategy: "Naked puts",
          realisedProfitAndLoss: 2.18,
          dateOpened: "2021-06-29T00:00:00.000Z",
          dateClosed: "2021-07-23T00:00:00.000Z",
        },
        {
          stockTicker: "X",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 3,
          quantity: null,
          premium: 1.29,
          spotPriceAtTradeTime: 24.61,
          strikePrice: 23.5,
          strategy: "Long call",
          realisedProfitAndLoss: 2.88,
          dateOpened: "2021-07-13T00:00:00.000Z",
          dateClosed: "2021-08-02T00:00:00.000Z",
        },
        {
          stockTicker: "GPS",
          tradeType: "CALL",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 0.19,
          spotPriceAtTradeTime: 29.17,
          strikePrice: 32,
          strategy: "Long call",
          realisedProfitAndLoss: 0.18,
          dateOpened: "2021-08-02T00:00:00.000Z",
          dateClosed: "2021-08-13T00:00:00.000Z",
        },
        {
          stockTicker: "F",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 8,
          quantity: null,
          premium: 1.29,
          spotPriceAtTradeTime: 13.96,
          strikePrice: 13,
          strategy: "Long call",
          realisedProfitAndLoss: -7.76,
          dateOpened: "2021-08-02T00:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "DIS",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 2.58,
          spotPriceAtTradeTime: 177.58,
          strikePrice: 175,
          strategy: "Long call",
          realisedProfitAndLoss: 2.39,
          dateOpened: "2021-08-11T00:00:00.000Z",
          dateClosed: "2021-08-13T00:00:00.000Z",
        },
        {
          stockTicker: "LAC",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 2.57,
          spotPriceAtTradeTime: 18.81,
          strikePrice: 25,
          strategy: "Long call",
          realisedProfitAndLoss: -2.8,
          dateOpened: "2021-08-12T00:00:00.000Z",
          dateClosed: "2021-08-17T00:00:00.000Z",
        },
        {
          stockTicker: "GPS",
          tradeType: "CALL",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 0.44,
          spotPriceAtTradeTime: 29.46,
          strikePrice: 30,
          strategy: "Long call",
          realisedProfitAndLoss: 0.74,
          dateOpened: "2021-08-13T00:00:00.000Z",
          dateClosed: "2021-08-15T23:00:00.000Z",
        },
        {
          stockTicker: "CAT",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 3.71,
          spotPriceAtTradeTime: 218.99,
          strikePrice: 250,
          strategy: "Long call",
          realisedProfitAndLoss: -2.21,
          dateOpened: "2021-08-13T00:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "GPS",
          tradeType: "CALL",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 0.56,
          spotPriceAtTradeTime: 28,
          strikePrice: 32,
          strategy: "Long call",
          realisedProfitAndLoss: 0.4600000000000001,
          dateOpened: "2021-08-15T23:00:00.000Z",
          dateClosed: "2021-08-17T00:00:00.000Z",
        },
        {
          stockTicker: "GPS",
          tradeType: "CALL",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 0.51,
          spotPriceAtTradeTime: 26.8,
          strikePrice: 26.5,
          strategy: "Covered call",
          realisedProfitAndLoss: -1.6600000000000001,
          dateOpened: "2021-08-17T00:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "WGO",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 10.3,
          spotPriceAtTradeTime: 73.42,
          strikePrice: 65,
          strategy: "Long call",
          realisedProfitAndLoss: 0.5999999999999996,
          dateOpened: "2021-08-02T00:00:00.000Z",
          dateClosed: "2021-08-05T23:00:00.000Z",
        },
        {
          stockTicker: "MARA",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.06,
          spotPriceAtTradeTime: 36.62,
          strikePrice: 31.5,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: 1.03,
          dateOpened: "2021-08-09T00:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "AAL",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 3,
          quantity: null,
          premium: 0.25,
          spotPriceAtTradeTime: 20.89,
          strikePrice: 20,
          strategy: "Long call",
          realisedProfitAndLoss: -3.87,
          dateOpened: "2021-08-11T00:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "SQ",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 9.7,
          spotPriceAtTradeTime: 272.13,
          strikePrice: 270,
          strategy: "Covered call",
          realisedProfitAndLoss: 9.7,
          dateOpened: "2021-08-24T00:00:00.000Z",
          dateClosed: "2021-09-20T00:00:00.000Z",
        },
        {
          stockTicker: "EL",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 14.8,
          spotPriceAtTradeTime: 337.93,
          strikePrice: 330,
          strategy: "Naked puts",
          realisedProfitAndLoss: -2.1000000000000014,
          dateOpened: "2021-08-24T00:00:00.000Z",
          dateClosed: "2021-09-07T00:00:00.000Z",
        },
        {
          stockTicker: "SBUX",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 17.72,
          spotPriceAtTradeTime: 117.19,
          strikePrice: 100,
          strategy: "Long call",
          realisedProfitAndLoss: -3.619999999999999,
          dateOpened: "2021-09-02T00:00:00.000Z",
          dateClosed: "2021-09-26T23:00:00.000Z",
        },
        {
          stockTicker: "UDR",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 5.5,
          spotPriceAtTradeTime: 55.25,
          strikePrice: 50,
          strategy: "Naked puts",
          realisedProfitAndLoss: -4.4,
          dateOpened: "2021-09-01T00:00:00.000Z",
          dateClosed: "2021-09-26T23:00:00.000Z",
        },
        {
          stockTicker: "GPS",
          tradeType: "STOCK",
          action: "BUY",
          positionStatus: "CLOSED",
          quantity: 200,
          spotPriceAtTradeTime: 32,
          strategy: "Covered call",
          realisedProfitAndLoss: -836,
          dateOpened: "2021-07-30T23:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "COPX",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.1,
          spotPriceAtTradeTime: 38.11,
          strikePrice: 38,
          strategy: "Long call",
          realisedProfitAndLoss: -3.8000000000000003,
          dateOpened: "2021-08-02T00:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "APPS",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 3,
          spotPriceAtTradeTime: 62.95,
          strikePrice: 60,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: -8.65,
          dateOpened: "2021-08-02T00:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "CLOV",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 10,
          quantity: null,
          premium: 0.37,
          spotPriceAtTradeTime: 8.36,
          strikePrice: 13,
          strategy: "Long call",
          realisedProfitAndLoss: -1.6,
          dateOpened: "2021-08-13T00:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "XLB",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 3,
          quantity: null,
          premium: 2.12,
          spotPriceAtTradeTime: 86.47,
          strikePrice: 90,
          strategy: "Long call",
          realisedProfitAndLoss: -2.37,
          dateOpened: "2021-08-13T00:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "LEG",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 4,
          quantity: null,
          premium: 1.3,
          spotPriceAtTradeTime: 49.75,
          strikePrice: 50,
          strategy: "Long call",
          realisedProfitAndLoss: -3.2,
          dateOpened: "2021-08-13T00:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "KSS",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 10.1,
          spotPriceAtTradeTime: 59.96,
          strikePrice: 52.5,
          strategy: "Long call",
          realisedProfitAndLoss: -8.6,
          dateOpened: "2021-08-24T00:00:00.000Z",
          dateClosed: "2021-09-07T00:00:00.000Z",
        },
        {
          stockTicker: "APPS",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 2.63,
          spotPriceAtTradeTime: 62.95,
          strikePrice: 60,
          strategy: "Pre-strategy",
          realisedProfitAndLoss: 2.63,
          dateOpened: "2021-08-02T00:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "MRO",
          tradeType: "CALL",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 4,
          quantity: null,
          premium: 0.24,
          spotPriceAtTradeTime: 11.55,
          strikePrice: 11.5,
          strategy: "Long call",
          realisedProfitAndLoss: 0.9199999999999999,
          dateOpened: "2021-08-17T00:00:00.000Z",
          dateClosed: "2021-08-20T00:00:00.000Z",
        },
        {
          stockTicker: "NET",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 20.7,
          spotPriceAtTradeTime: 123.56,
          strikePrice: 105,
          strategy: "Long call",
          realisedProfitAndLoss: -3.1499999999999986,
          dateOpened: "2021-08-24T00:00:00.000Z",
          dateClosed: "2021-09-26T23:00:00.000Z",
        },
        {
          stockTicker: "PEAK",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 5,
          quantity: null,
          premium: 2.07,
          spotPriceAtTradeTime: 36.57,
          strikePrice: 35,
          strategy: "Long call",
          realisedProfitAndLoss: -9.1,
          dateOpened: "2021-09-01T00:00:00.000Z",
          dateClosed: "2021-09-26T23:00:00.000Z",
        },
        {
          stockTicker: "QCOM",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 13.6,
          spotPriceAtTradeTime: 147.26,
          strikePrice: 135,
          strategy: "Long call",
          realisedProfitAndLoss: -10.16,
          dateOpened: "2021-09-01T00:00:00.000Z",
          dateClosed: "2021-09-17T00:00:00.000Z",
        },
        {
          stockTicker: "TWTR",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 6.76,
          spotPriceAtTradeTime: 65.77,
          strikePrice: 60,
          strategy: "Long call",
          realisedProfitAndLoss: -4.82,
          dateOpened: "2021-09-02T00:00:00.000Z",
          dateClosed: "2021-09-09T00:00:00.000Z",
        },
        {
          stockTicker: "HD",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 14.35,
          spotPriceAtTradeTime: 330.34,
          strikePrice: 320,
          strategy: "Long call",
          realisedProfitAndLoss: 5.500000000000002,
          dateOpened: "2021-09-07T00:00:00.000Z",
          dateClosed: "2021-09-17T00:00:00.000Z",
        },
        {
          stockTicker: "SQ",
          tradeType: "CALL",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.11,
          spotPriceAtTradeTime: 248.44,
          strikePrice: 270,
          strategy: "Covered call",
          realisedProfitAndLoss: 1.05,
          dateOpened: "2021-09-20T00:00:00.000Z",
          dateClosed: "2021-09-30T00:00:00.000Z",
        },
        {
          stockTicker: "TQQQ",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 1.32,
          spotPriceAtTradeTime: 138.79,
          strikePrice: 125,
          strategy: "Long call",
          realisedProfitAndLoss: 2.64,
          dateOpened: "2021-09-26T23:00:00.000Z",
          dateClosed: "2021-10-08T00:00:00.000Z",
        },
        {
          stockTicker: "ORCL",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 6.15,
          spotPriceAtTradeTime: 89.57,
          strikePrice: 85,
          strategy: "Long call",
          realisedProfitAndLoss: 9.46,
          dateOpened: "2021-09-23T00:00:00.000Z",
          dateClosed: "2021-10-14T00:00:00.000Z",
        },
        {
          stockTicker: "SQ",
          tradeType: "CALL",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: 1,
          premium: 0.67,
          spotPriceAtTradeTime: 236.04,
          strikePrice: 270,
          strategy: "Covered call",
          realisedProfitAndLoss: 0.6100000000000001,
          dateOpened: "2021-09-30T00:00:00.000Z",
          dateClosed: "2021-10-12T00:00:00.000Z",
        },
        {
          stockTicker: "DLO",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 5,
          quantity: null,
          premium: 1.35,
          spotPriceAtTradeTime: 52.36,
          strikePrice: 70,
          strategy: "Naked puts",
          realisedProfitAndLoss: -5.5,
          dateOpened: "2021-10-11T00:00:00.000Z",
          dateClosed: "2021-10-25T00:00:00.000Z",
        },
        {
          stockTicker: "SQ",
          tradeType: "CALL",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 0.75,
          spotPriceAtTradeTime: 238.99,
          strikePrice: 270,
          strategy: "Covered call",
          realisedProfitAndLoss: 0.75,
          dateOpened: "2021-10-12T00:00:00.000Z",
          dateClosed: "2021-10-29T00:00:00.000Z",
        },
        {
          stockTicker: "TQQQ",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 2.5,
          spotPriceAtTradeTime: 132.97,
          strikePrice: 124,
          strategy: "Long call",
          realisedProfitAndLoss: 5,
          dateOpened: "2021-10-14T00:00:00.000Z",
          dateClosed: "2021-10-29T00:00:00.000Z",
        },
        {
          stockTicker: "SBSW",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 3,
          quantity: null,
          premium: 0.71,
          spotPriceAtTradeTime: 15.28,
          strikePrice: 15,
          strategy: "Long call",
          realisedProfitAndLoss: -1.7100000000000002,
          dateOpened: "2021-10-15T00:00:00.000Z",
          dateClosed: "2021-10-25T00:00:00.000Z",
        },
        {
          stockTicker: "SQ",
          tradeType: "CALL",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 0.78,
          spotPriceAtTradeTime: 254.5,
          strikePrice: 285,
          strategy: "Covered call",
          realisedProfitAndLoss: 0.22999999999999998,
          dateOpened: "2021-10-31T22:00:00.000Z",
          dateClosed: "2021-11-03T00:00:00.000Z",
        },
        {
          stockTicker: "ABNB",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 9.5,
          spotPriceAtTradeTime: 173.04,
          strikePrice: 200,
          strategy: "Long call",
          realisedProfitAndLoss: 32.2,
          dateOpened: "2021-11-03T00:00:00.000Z",
          dateClosed: "2021-11-08T00:00:00.000Z",
        },
        {
          stockTicker: "DLO",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 6.3,
          spotPriceAtTradeTime: 50.42,
          strikePrice: 65,
          strategy: "Long call",
          realisedProfitAndLoss: -2.5999999999999996,
          dateOpened: "2021-11-03T00:00:00.000Z",
          dateClosed: "2021-11-10T00:00:00.000Z",
        },
        {
          stockTicker: "U",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 16.6,
          spotPriceAtTradeTime: 152.59,
          strikePrice: 170,
          strategy: "Long call",
          realisedProfitAndLoss: 25.1,
          dateOpened: "2021-11-03T22:00:00.000Z",
          dateClosed: "2021-11-16T00:00:00.000Z",
        },
        {
          stockTicker: "SQ",
          tradeType: "CALL",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 3.45,
          spotPriceAtTradeTime: 247.46,
          strikePrice: 270,
          strategy: "Covered call",
          realisedProfitAndLoss: 3.2800000000000002,
          dateOpened: "2021-11-05T00:00:00.000Z",
          dateClosed: "2021-11-12T00:00:00.000Z",
        },
        {
          stockTicker: "SQ",
          tradeType: "CALL",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.39,
          spotPriceAtTradeTime: 236,
          strikePrice: 270,
          strategy: "Covered call",
          realisedProfitAndLoss: 1.13,
          dateOpened: "2021-11-15T00:00:00.000Z",
          dateClosed: "2021-11-24T00:00:00.000Z",
        },
        {
          stockTicker: "EBAY",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 6,
          quantity: null,
          premium: 6.5,
          spotPriceAtTradeTime: 76.17,
          strikePrice: 75,
          strategy: "Long call",
          realisedProfitAndLoss: -32.7,
          dateOpened: "2021-11-16T00:00:00.000Z",
          dateClosed: "2022-01-10T00:00:00.000Z",
        },
        {
          stockTicker: "ORCL",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 9,
          quantity: null,
          premium: 4.33,
          spotPriceAtTradeTime: 95.81,
          strikePrice: 100,
          strategy: "Long call",
          realisedProfitAndLoss: -26.82,
          dateOpened: "2021-11-16T00:00:00.000Z",
          dateClosed: "2022-01-10T00:00:00.000Z",
        },
        {
          stockTicker: "FB",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 33.45,
          spotPriceAtTradeTime: 341.69,
          strikePrice: 350,
          strategy: "Long call",
          realisedProfitAndLoss: -14.450000000000003,
          dateOpened: "2021-11-17T00:00:00.000Z",
          dateClosed: "2022-01-10T00:00:00.000Z",
        },
        {
          stockTicker: "A",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 3,
          quantity: null,
          premium: 10.57,
          spotPriceAtTradeTime: 162.03,
          strikePrice: 165,
          strategy: "Long call",
          realisedProfitAndLoss: -24.509999999999998,
          dateOpened: "2021-11-18T00:00:00.000Z",
          dateClosed: "2022-01-10T00:00:00.000Z",
        },
        {
          stockTicker: "KRBN",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 2.35,
          spotPriceAtTradeTime: 52.04,
          strikePrice: 50,
          strategy: "Naked puts",
          realisedProfitAndLoss: 2.35,
          dateOpened: "2021-12-16T00:00:00.000Z",
          dateClosed: "2022-01-24T00:00:00.000Z",
        },
        {
          stockTicker: "MSFT",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 23.47,
          spotPriceAtTradeTime: 330.38,
          strikePrice: 350,
          strategy: "Long call",
          realisedProfitAndLoss: -9.469999999999999,
          dateOpened: "2021-12-22T00:00:00.000Z",
          dateClosed: "2022-01-10T00:00:00.000Z",
        },
        {
          stockTicker: "DBA",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 2,
          quantity: null,
          premium: 0.3,
          spotPriceAtTradeTime: 19.95,
          strikePrice: 20,
          strategy: "Naked puts",
          realisedProfitAndLoss: 0.6,
          dateOpened: "2021-12-29T00:00:00.000Z",
          dateClosed: "2022-01-24T00:00:00.000Z",
        },
        {
          stockTicker: "SARK",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.25,
          spotPriceAtTradeTime: 37.63,
          strikePrice: 37,
          strategy: "Naked puts",
          realisedProfitAndLoss: 1.1,
          dateOpened: "2021-12-29T00:00:00.000Z",
          dateClosed: "2022-01-12T00:00:00.000Z",
        },
        {
          stockTicker: "URNM",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.35,
          spotPriceAtTradeTime: 72.55,
          strikePrice: 65,
          strategy: "Naked puts",
          realisedProfitAndLoss: 1.35,
          dateOpened: "2021-12-29T00:00:00.000Z",
          dateClosed: "2022-01-24T00:00:00.000Z",
        },
        {
          stockTicker: "SARK",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "OPEN",
          contracts: 1,
          quantity: null,
          premium: 1.95,
          spotPriceAtTradeTime: 40.13,
          strikePrice: 55,
          strategy: "Long call",
          dateOpened: "2022-01-06T00:00:00.000Z",
        },
        {
          stockTicker: "SARK",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "OPEN",
          contracts: 8,
          quantity: null,
          premium: 2.4,
          spotPriceAtTradeTime: 42.59,
          strikePrice: 55,
          strategy: "Long call",
          dateOpened: "2022-01-10T00:00:00.000Z",
        },
        {
          stockTicker: "HTZZ",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 1,
          quantity: null,
          premium: 1.35,
          spotPriceAtTradeTime: null,
          strikePrice: 22.5,
          strategy: "Naked puts",
          realisedProfitAndLoss: -4.300000000000001,
          dateOpened: "2022-01-11T00:00:00.000Z",
          dateClosed: "2022-01-24T00:00:00.000Z",
        },
        {
          stockTicker: "UUUU",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 10,
          quantity: null,
          premium: 3.4,
          spotPriceAtTradeTime: 8.225,
          strikePrice: 7,
          strategy: "LEAP ",
          realisedProfitAndLoss: -16.4,
          dateOpened: "2022-01-12T00:00:00.000Z",
          dateClosed: "2022-01-24T00:00:00.000Z",
        },
        {
          stockTicker: "BTU",
          tradeType: "PUT",
          action: "SELL_TO_OPEN",
          positionStatus: "CLOSED",
          contracts: 4,
          quantity: null,
          premium: 1.25,
          spotPriceAtTradeTime: 13.43,
          strikePrice: 13,
          strategy: "Naked puts",
          realisedProfitAndLoss: -8.6,
          dateOpened: "2022-01-18T00:00:00.000Z",
          dateClosed: "2022-01-24T00:00:00.000Z",
        },
        {
          stockTicker: "SPY",
          tradeType: "CALL",
          action: "BUY_TO_OPEN",
          positionStatus: "OPEN",
          contracts: 2,
          quantity: null,
          premium: 22.64,
          spotPriceAtTradeTime: 430.04,
          strikePrice: 460,
          strategy: "LEAP ",
          dateOpened: "2022-01-24T00:00:00.000Z",
        },
      ],
    };
    return (
      <div className={styles.mainAppContainer}>
        {this.state.loading === false && (
          <PromoCouponBanner data={this.state.promo} />
        )}

        <WealthBeeBanner />

        {navigator.userAgent !== "ReactSnap" && <SimpleHeader />}
        <NavBar
          amplitude={amplitude}
          days={this.state.trial_days}
          loading={this.state.trial_days_loading}
        />

        {navigator.userAgent !== "ReactSnap" && (
          <>
            <Hero
              amplitude={amplitude}
              days={this.state.trial_days}
              loading={this.state.trial_days_loading}
            />
            <Gallery />

            <Features />

            <TryItOut1 />

            {/* Perf */}
            <TextSection
              component={
                <Frame>
                  <ExampleCharts
                    examplechartdata={examplechartdata}
                    componentId="tradesTable"
                  />
                </Frame>
              }
              cPosition="blurBottomLeft"
              color="blue"
              direction="left"
              title={"Performance analysis"}
              description={[
                `Track your performance over time, by portfolio and by strategy`,
                `View multiple charts including best days, best strategies, average greeks`,
                `Track breakeven, credits, debits, DTE, P&L, premium, total risk, commission`,
              ]}
            />

            {/* Hist */}
            <TextSection
              component={
                <Frame>
                  <ExampleCharts
                    examplechartdata={examplechartdata}
                    componentId="strategy"
                  />
                </Frame>
              }
              cPosition="blurTopRight"
              color="green"
              direction="right"
              title={"Historical analysis"}
              description={[
                `Track which of your strategies performed best`,
                `Use tagging and grouping to view metrics by transaction, position or strategy`,
                `See metrics including cost basis, break-even, P&L, premium, total risk, DTE, commission, trends`,
              ]}
            />

            <TextSection
              component={<OptionTradeAnalysisExample />}
              cPosition="blurTopRight"
              color="blue"
              direction="left"
              title={"Option Analysis"}
              description={[
                `Performance analysis of your option trades`,
                `Track how the greeks, open interest & volume impact option prices`,
                `View options chains and see how the greeks change as the underlying price changes`,
                // `Naked put screener to find the best options for you`,
              ]}
            />

            {/* Fund */}
            <TextSection
              component={<FundementalExample />}
              cPosition="blurBottomLeft"
              color="yellow"
              direction="right"
              title={"Fundamental analysis"}
              description={[
                `View how fundamentals have changed since a trade was opened`,
                `Analyze stocks and see detailed data points including PEG, PE, Dividend Yield and 100s more`,
                `Look up any stock and see the latest news, earnings, financials, and more`,
              ]}
            />

            {/* OptionLookup */}
            <TextSection
              component={
                <HStack>
                  <motion.div
                    drag
                    dragConstraints={{
                      top: -50,
                      left: -50,
                      right: 50,
                      bottom: 50,
                    }}
                    animate={{
                      // scale: [1, 1.5, 1],
                      rotate: [0, 0],
                      translateY: [0, -5, 0],
                    }}
                    transition={{ duration: 2, repeat: Infinity }}
                  >
                    {/*  */}
                    <HistoricalOptionData demo={true} />
                  </motion.div>
                </HStack>
              }
              cPosition="blurTopRight"
              color="blue"
              direction="left"
              title={"Option Screener"}
              description={[
                `Scan for options by ticker, expiry and strike`,
                `View option chains, IV, Vega, Theta, Gamma, Delta and more`,
                `View option prices and charts`,
              ]}
            />

            {/* Portfolio */}
            <TextSection
              component={
                <Box
                  backgroundColor="var(--black)"
                  borderRadius={"12px"}
                  paddingLeft="20px"
                  paddingRight={"20px"}
                >
                  <AccountPicker demo={true} />
                </Box>
              }
              cPosition="blurBottomLeft"
              direction="right"
              title={"Unlimited portfolios"}
              description={[
                "Add unlimited portfolios",
                "Add trades for capital, income and family",
                "View all of your trades in one place",
              ]}
            />

            {/* Trades */}
            <TextSection
              component={
                <Box height="330px" width="100%" transform={"translateY(50px)"}>
                  <ExampleCharts
                    examplechartdata={examplechartdata}
                    homepage={true}
                    componentId="diversificationTable"
                  />
                </Box>
              }
              cPosition="blurTopRight"
              color="blue"
              direction="left"
              title={"Unlimited trades"}
              description={[
                "Add an unlimited number of trades",
                "Includes options, stocks, ETFs and ETNs",
                "Tag trades and then review performance",
              ]}
            />

            {/* Multi */}
            <TextSection
              component={
                <ExampleCharts
                  examplechartdata={examplechartdata}
                  componentId="widgetTotalRisk"
                />
              }
              cPosition="blurBottomLeft"
              color="yellow"
              direction="right"
              title={"Multi-leg trades"}
              description={[
                `Support for adding and viewing multi-leg trades`,
                `Group trades by stock ticker, strategy and more`,
                `Calculate your true risk and portfolio value`,
              ]}
            />

            {/* Jour/Notif */}
            <TextSection
              component={
                <HStack>
                  <motion.div
                    drag
                    dragConstraints={{
                      top: -50,
                      left: -50,
                      right: 50,
                      bottom: 50,
                    }}
                    animate={{
                      // scale: [1, 1.5, 1],
                      rotate: [0, 0],
                      translateY: [0, 10, 0],
                    }}
                    transition={{ duration: 2, repeat: Infinity }}
                  >
                    <Tag
                      bg="var(--green)"
                      paddingLeft="4"
                      paddingRight="4"
                      paddingTop="2"
                      paddingBottom="2"
                      fontSize={"16px"}
                      borderRadius="full"
                      variant="solid"
                      textShadow={"var(--bg) 0px 0px 10px"}
                    >
                      <TagLabel>Active</TagLabel>
                    </Tag>
                  </motion.div>

                  <motion.div
                    drag
                    dragConstraints={{
                      top: -50,
                      left: -50,
                      right: 50,
                      bottom: 50,
                    }}
                    animate={{
                      // scale: [1, 1.5, 1],
                      rotate: [0, 0],
                      translateY: [0, -5, 0],
                    }}
                    transition={{ duration: 2, repeat: Infinity }}
                  >
                    <Tag
                      bg="var(--accent)"
                      paddingLeft="4"
                      paddingRight="4"
                      paddingTop="2"
                      paddingBottom="2"
                      fontSize={"16px"}
                      borderRadius="full"
                      variant="solid"
                      textShadow={"var(--bg) 0px 0px 10px"}
                    >
                      <TagLabel>Sent</TagLabel>
                    </Tag>
                  </motion.div>

                  <motion.div
                    drag
                    dragConstraints={{
                      top: -50,
                      left: -50,
                      right: 50,
                      bottom: 50,
                    }}
                    animate={{
                      // scale: [1, 1.5, 1],
                      rotate: [0, 0],
                      translateY: [0, -8, 0],
                    }}
                    transition={{ duration: 4, repeat: Infinity }}
                  >
                    <Tag
                      bg="var(--red)"
                      paddingLeft="4"
                      paddingRight="4"
                      paddingTop="2"
                      paddingBottom="2"
                      fontSize={"16px"}
                      borderRadius="full"
                      variant="solid"
                      textShadow={"var(--bg) 0px 0px 10px"}
                    >
                      <TagLabel>Expired</TagLabel>
                    </Tag>
                  </motion.div>
                </HStack>
              }
              cPosition="blurTopRight"
              color="yellow"
              direction="left"
              title={"Notifications"}
              description={[
                `Record notes and reminders for your trades`,
                `Create notifications to remind you of important events`,
                `Record notes against trades or daily activity in a calendar view. View upcoming expiries.`,
              ]}
            />

            <TextSection
              component={<FakeCalendarDate />}
              cPosition="blurBottomLeft"
              color="green"
              direction="right"
              title={"Journaling"}
              description={[
                `Record notes against trades or daily activity in a calendar view`,
                `View upcoming expiries`,
                `View P&L by day.`,
              ]}
            />

            {/* Import */}
            <TextSection
              component={
                <Box>
                  <SecondaryButton
                    backgroundColor="var(--bg)"
                    border="solid var(--accent) 1px"
                    onClick={() => {
                      this.setState({ showConfetti: true });

                      setTimeout(() => {
                        this.setState({ showConfetti: false });
                      }, 3000);
                    }}
                  >
                    {this.state.showConfetti === false && (
                      <>
                        Uploading
                        <Spinner ml="5" size="xs" />
                      </>
                    )}
                    {this.state.showConfetti === true && <>Hello!</>}
                  </SecondaryButton>

                  <Box transform={"translateX(60px)"}>
                    <Confetti
                      active={this.state.showConfetti}
                      config={{
                        spread: 100,
                        width: "10px",
                        height: "10px",
                        dragFriction: 0.05,
                        stagger: 10.5,
                        startVelocity: 20,
                        elementCount: 200,
                      }}
                    />
                  </Box>
                </Box>
              }
              cPosition="blurTopRight"
              color="blue"
              direction="left"
              title={"Import your trades"}
              description={[
                `Supports automated imports for TD Ameritrade, Schwab, Fidelity and more`,
                `Add trades manually or import from from your broker`,
                // `Supports AutoSync for Interactive Brokers`,
              ]}
            />

            <Upload />

            <Pricing
              amplitude={amplitude}
              trial_days={{
                days: this.state.trial_days,
                loading: this.state.trial_days_loading,
              }}
            />

            <Footer amplitude={amplitude} />
          </>
        )}
      </div>
    );
  }
}

const TBDComp = () => {
  return (
    <Box
      backgroundColor="var(--black)"
      borderRadius={"12px"}
      paddingLeft="20px"
      paddingRight={"20px"}
    >
      <Text>Example to be completed</Text>
    </Box>
  );
};

const OptionTradeAnalysisExample = () => {
  const [number, setNumber] = useState(50);
  const [greek, setGreek] = useState("IV");

  const arrayOfGreeks = ["IV", "Rho", "Vega", "Theta", "Gamma", "Delta"];

  useEffect(() => {
    setInterval(() => {
      setNumber(
        number +
          Math.floor(
            Math.random() * (number * 1.5 - number * 0.5 + 1) + number * 0
          )
      );
    }, 4000);

    setInterval(() => {
      setGreek(arrayOfGreeks[Math.floor(Math.random() * arrayOfGreeks.length)]);
    }, 4000);
  }, []);

  return (
    <Box
      paddingLeft="20px"
      paddingRight={"20px"}
      display="flex"
      justifyContent={"center"}
      flexDir="column"
      alignItems={"center"}
    >
      <Title>{greek} </Title>
      {number > 60 ? (
        <HStack>
          <Icon className={stylesX.positiveIcon} as={TriangleUp}></Icon>
          <Text className={stylesX.statChangePositive} fontSize="20px">
            <CountUp
              end={number}
              decimals={2}
              decimal="."
              prefix=""
              suffix="%"
            />
          </Text>
        </HStack>
      ) : (
        <HStack>
          <Icon className={stylesX.negativeIcon} as={TriangleDown}></Icon>
          <Text className={stylesX.statChangeNegative} fontSize="20px">
            <CountUp
              end={number}
              decimals={2}
              decimal="."
              prefix=""
              suffix="%"
            />
          </Text>
        </HStack>
      )}

      {number > 60 ? (
        <Text color="var(--green)">You win more when {greek} is higher</Text>
      ) : (
        <Text color="var(--red)">You lose more when {greek} is lower</Text>
      )}
    </Box>
  );
};

const FakeCalendarDate = () => {
  return (
    <Box
      width="180px"
      height="180px"
      display="flex"
      justifyContent={"space-between"}
      borderRadius="6px"
      alignItems="center"
      flexDir={"column"}
      border="1px solid var(--dark-gray)"
    >
      <Text zIndex={5} paddingTop="10px" fontWeight={500} color="var(--white)">
        18th
      </Text>
      <VStack zIndex={5} paddingBottom="50px">
        <Text zIndex={5} color="var(--green)" fontWeight={700} fontSize="20px">
          $12,735
        </Text>
        <Text zIndex={5} color="var(--semi-white)" fontSize={"14px"}>
          2 TRADES
        </Text>
      </VStack>
      <Box
        zIndex={0}
        width="180px"
        height="180px"
        background={"var(--calendarProfit)"}
        borderRadius="6px"
        opacity="0.8"
        pos={"absolute"}
      />
    </Box>
  );
};

const FundementalExample = () => {
  const [number, setNumber] = useState(24.353);
  const [fundamental, setFundamental] = useState("PE");

  const arrayOfFundamentals = ["PE"];

  function abbreviateNumber(value) {
    var newValue = value;
    if (value >= 1000) {
      var suffixes = ["", "k", "m", "b", "t"];
      var suffixNum = Math.floor(("" + value).length / 3);
      var shortValue = "";
      for (var precision = 2; precision >= 1; precision--) {
        shortValue = parseFloat(
          (suffixNum != 0
            ? value / Math.pow(1000, suffixNum)
            : value
          ).toPrecision(precision)
        );
        var dotLessShortValue = (shortValue + "").replace(
          /[^a-zA-Z 0-9]+/g,
          ""
        );
        if (dotLessShortValue.length <= 2) {
          break;
        }
      }
      if (shortValue % 1 != 0) shortValue = shortValue.toFixed(1);
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  }

  useEffect(() => {
    setInterval(() => {
      setNumber(
        number +
          Math.floor(
            Math.random() * (number * 1.5 - number * 0.5 + 1) + number * 0
          )
      );
      setFundamental(
        arrayOfFundamentals[
          Math.floor(Math.random() * arrayOfFundamentals.length)
        ]
      );
    }, 4000);
  }, []);

  return (
    <Box
      paddingLeft="20px"
      paddingRight={"20px"}
      display="flex"
      justifyContent={"center"}
      flexDir="column"
      alignItems={"center"}
    >
      <HStack flexWrap={"wrap"}>
        <FundamentalItem
          fundamental={"PE"}
          number={number}
          color="var(--accent)"
        />
        <FundamentalItem
          fundamental={"PEG"}
          number={number - 25}
          color="var(--green)"
        />
        <FundamentalItem
          fundamental={"Div"}
          number={number - 20}
          color="var(--red)"
        />
      </HStack>
    </Box>
  );
};

const FundamentalItem = ({ fundamental, number, color }) => {
  number =
    number +
    Math.floor(Math.random() * (number * 1.5 - number * 0.5 + 1) + number * 0);

  return (
    <VStack width="80px">
      <Title>{fundamental} </Title>
      <Text
        className={stylesX.statChangePositive}
        color={color}
        fontSize="20px"
      >
        <CountUp end={number} decimals={3} decimal="." prefix="" suffix="" />
      </Text>
    </VStack>
  );
};

const Frame = (props) => {
  return (
    <Box
      width={"450px"}
      maxH="90%"
      maxW="90%"
      borderRadius={"12px"}
      paddingLeft="20px"
      paddingRight={"20px"}
    >
      {props.children}
    </Box>
  );
};

const mapStateToProps = (state) => {
  const { settings } = state;
  return { settings };
};

export default connect(mapStateToProps)(App);
